import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'

/**
 * 北恩U880 多标签页共享版
 * 1. 主动关闭WS不自动重连（支持多标签页接力使用设备）
 * 2. 异常断开仍自动重连
 * 3. 六道防线杜绝挂断后二次录音
 * 4. 上传失败自动重试
 */
const usbphone = {
    state: {
        wsClient: null,
        wsip: 'ws://127.0.0.1:823',
        inp_recordaddr: "",
        tip: [],
        spush: [],

        p_status: 0,
        r_status: 0,
        a_status: 0,
        dv_status: 0,
        icm_flag: 0,
        has_dial: false,
        pre_p_status: 0,

        ringCount: 0,
        incomTimeout: null,
        autoRecordID: null,
        dlyDlokTimeout: null,
        phoneCode: null,
        phoneCodeShow: null,

        serialno: null,
        cnnstate: null,
        messagenum: null,
        inp_phonecode: null,
        inp_serial: null,

        SetLeaveRecordFlag: 0,
        holdTo503: false,
        isDialOnline: false,
        PreDialing: false,

        phone_icm: '',
        audioend: 0,
        rd_icm: false,
        pre_command: '',

        modalVisible: false,
        modalCurentInfo: {
            customer_id: null,
            full_name: '',
            phone: '',
            zipid: null,
            reason: '',
            remark: '',
        },

        callMonitorTimer: null,
        lastMessageTime: Date.now(),
        lastCallEventTime: Date.now(),
        isConnected: false,

        heartTimer: null,
        uploadingRecord: false,
        uploadTimer: null,
        uploadTipLock: false,
        isStoppingRecord: false,
        isHangUping: false,
        uploadRetried: false,
        // 主动关闭标记，true=用户主动关的，不自动重连
        isManualClose: false,

        // ========== 新增多标签页锁 ==========
        lockId: null,                       // 当前标签页持有的锁ID
        shouldDisconnectAfterUpload: false, // 挂断后需等待上传完成再断开WS
        _beforeUnloadHandler: null,         // beforeunload清理句柄
    },
    mutations: {
        SET_TIP: (state, tip) => { state.tip = tip },
        SET_WSCLIENT: (state, wsClient) => { state.wsClient = wsClient },
        SET_INP_RECORDADDR: (state, inp_recordaddr) => { state.inp_recordaddr = inp_recordaddr },
        SET_WSIP: (state, wsip) => { state.wsip = wsip },
        SET_P_STATUS: (state, p_status) => { state.p_status = p_status },
        SET_R_STATUS: (state, r_status) => { state.r_status = r_status },
        SET_A_STATUS: (state, a_status) => { state.a_status = a_status },
        SET_DV_STATUS: (state, dv_status) => { state.dv_status = dv_status },
        SET_ICM_FLAG: (state, icm_flag) => { state.icm_flag = icm_flag },
        SET_HAS_DIAL: (state, has_dial) => { state.has_dial = has_dial },
        SET_PRE_P_STATUS: (state, pre_p_status) => { state.pre_p_status = pre_p_status },
        SET_RINGCOUNT: (state, ringCount) => { state.ringCount = ringCount },
        SET_INCOM_TIMEOUT: (state, incomTimeout) => { state.incomTimeout = incomTimeout },
        SET_AUTORECORDID: (state, autoRecordID) => { state.autoRecordID = autoRecordID },
        SET_INP_SERIAL: (state, inp_serial) => { state.inp_serial = inp_serial },
        SET_CNNSTATE: (state, cnnstate) => { state.cnnstate = cnnstate },
        SET_MESSAGENUM: (state, messagenum) => { state.messagenum = messagenum },
        SET_PHONECODE: (state, phoneCode) => { state.phoneCode = phoneCode },
        SET_PHONECODESHOW: (state, phoneCodeShow) => { state.phoneCodeShow = phoneCodeShow },
        SET_INP_PHONECODE: (state, inp_phonecode) => { state.inp_phonecode = inp_phonecode },
        SET_SERIALNO: (state, serialno) => { state.serialno = serialno },
        SET_SPUSH: (state, spush) => { state.spush = spush },
        SET_SETLEAVERECORDFLAG: (state, SetLeaveRecordFlag) => { state.SetLeaveRecordFlag = SetLeaveRecordFlag },
        SET_HOLDTO503: (state, holdTo503) => { state.holdTo503 = holdTo503 },
        SET_ISDIALONLINE: (state, isDialOnline) => { state.isDialOnline = isDialOnline },
        SET_PREDIALING: (state, PreDialing) => { state.PreDialing = PreDialing },
        SET_PHONE_ICM: (state, phone_icm) => { state.phone_icm = phone_icm },
        SET_AUDIOEND: (state, audioend) => { state.audioend = audioend },
        SET_RD_ICM: (state, rd_icm) => { state.rd_icm = rd_icm },
        SET_PRE_COMMAND: (state, pre_command) => { state.pre_command = pre_command },
        SET_DLYDLOKTIMEOUT: (state, dlyDlokTimeout) => { state.dlyDlokTimeout = dlyDlokTimeout },
        SET_MODALVISIBLE: (state, modalVisible) => { state.modalVisible = modalVisible },
        SET_MODALCURENTINFO: (state, modalCurentInfo) => { state.modalCurentInfo = modalCurentInfo },
        SET_CALL_MONITOR_TIMER: (state, timer) => { state.callMonitorTimer = timer },
        SET_LAST_MESSAGE_TIME: (state) => { state.lastMessageTime = Date.now() },
        SET_LAST_CALL_EVENT_TIME: (state) => { state.lastCallEventTime = Date.now() },
        SET_IS_CONNECTED: (state, value) => { state.isConnected = value },
        SET_HEART_TIMER: (state, timer) => { state.heartTimer = timer },
        SET_UPLOADING_RECORD: (state, val) => { state.uploadingRecord = val },
        SET_UPLOAD_TIMER: (state, timer) => { state.uploadTimer = timer },
        SET_UPLOAD_TIP_LOCK: (state, val) => { state.uploadTipLock = val },
        SET_STOP_RECORD_LOCK: (state, val) => { state.isStoppingRecord = val },
        SET_HANGUP_LOCK: (state, val) => { state.isHangUping = val },
        SET_UPLOAD_RETRIED: (state, val) => { state.uploadRetried = val },
        SET_MANUAL_CLOSE: (state, val) => { state.isManualClose = val },
        // ========== 新增 ==========
        SET_LOCK_ID: (state, id) => { state.lockId = id },
        SET_SHOULD_DISCONNECT_AFTER_UPLOAD: (state, val) => { state.shouldDisconnectAfterUpload = val },
        SET_BEFOREUNLOAD_HANDLER: (state, handler) => { state._beforeUnloadHandler = handler },
    },
    actions: {
        safeSend({ state }, cmdStr) {
            if (!state.wsClient) return false
            if (state.wsClient.readyState !== WebSocket.OPEN) return false
            state.wsClient.send(cmdStr)
            return true
        },

        startHeartBeat({ state, commit, dispatch }) {
            if (state.heartTimer) clearInterval(state.heartTimer)
            const timer = setInterval(() => {
                if (state.wsClient && state.wsClient.readyState === WebSocket.OPEN) {
                    dispatch('sentNCommand', { cmd: "HP_GetPhoneStatus", rid: 8, para: null })
                }
            }, 5000)
            commit('SET_HEART_TIMER', timer)
        },
        stopHeartBeat({ state, commit }) {
            if (state.heartTimer) {
                clearInterval(state.heartTimer)
                commit('SET_HEART_TIMER', null)
            }
        },

        AddPhoneModal({ commit, state, dispatch }, { phone, customer_id, full_name }) {
            if (state.p_status != 0) {
                if (phone == state.modalCurentInfo.phone) {
                    dispatch('ShowPhoneModal')
                } else {
                    message.error('当前电话正在通话中，请先挂断再拨打')
                }
                return
            }
            commit('SET_MODALCURENTINFO', {
                customer_id: customer_id,
                full_name: full_name,
                phone: phone,
                zipid: null,
                reason: '',
                remark: '',
            })
            commit('SET_MODALVISIBLE', true)
        },
        ShowPhoneModal({ commit }) { commit('SET_MODALVISIBLE', true) },
        HidePhoneModal({ commit }) { commit('SET_MODALVISIBLE', false) },

        // ========== 主动断开WS（不自动重连）==========
        Disconnect({ commit, state, dispatch }) {
            console.log('【主动断开WS】释放设备，其他标签页可连接')
            commit('SET_MANUAL_CLOSE', true)
            dispatch('stopHeartBeat')

            if (state.callMonitorTimer) {
                clearInterval(state.callMonitorTimer)
                commit('SET_CALL_MONITOR_TIMER', null)
            }
            if (state.autoRecordID) {
                clearTimeout(state.autoRecordID)
                commit('SET_AUTORECORDID', null)
            }
            if (state.incomTimeout) {
                clearTimeout(state.incomTimeout)
                commit('SET_INCOM_TIMEOUT', null)
            }
            if (state.uploadTimer) {
                clearTimeout(state.uploadTimer)
                commit('SET_UPLOAD_TIMER', null)
            }

            if (state.wsClient) {
                try {
                    state.wsClient.close(1000, '主动断开')
                } catch (e) {
                    console.warn('关闭WS异常', e)
                }
            }
            commit('SET_WSCLIENT', null)
            commit('SET_UPLOADING_RECORD', false)
            commit('SET_STOP_RECORD_LOCK', false)
            commit('SET_HANGUP_LOCK', false)
            commit('SET_P_STATUS', 0)
            commit('SET_R_STATUS', 0)

            // ----- 释放锁 -----
            localStorage.removeItem('usbphone_lock')
            commit('SET_LOCK_ID', null)
            // 清理 beforeunload 监听
            if (state._beforeUnloadHandler) {
                window.removeEventListener('beforeunload', state._beforeUnloadHandler)
                commit('SET_BEFOREUNLOAD_HANDLER', null)
            }
            commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
        },

        // 统一挂断核心
        handleAllHangUp({ commit, state, dispatch }) {
            if (state.isHangUping) {
                console.log('【挂断防抖】已在挂断流程中，跳过重复调用')
                return
            }
            commit('SET_HANGUP_LOCK', true)
            console.log('【统一挂断流程执行】')

            if (state.autoRecordID) {
                clearTimeout(state.autoRecordID)
                commit('SET_AUTORECORDID', null)
            }
            if (state.callMonitorTimer) {
                clearInterval(state.callMonitorTimer)
                commit('SET_CALL_MONITOR_TIMER', null)
            }

            const recordPathBak = state.inp_recordaddr
            commit('SET_INP_RECORDADDR', '')
            commit('SET_UPLOAD_RETRIED', false)

            // 标记需要在上传完成后断开WS
            commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', true)

            dispatch('sentNCommand', { "cmd": "HP_HangUpCtrl", "rid": 4, "para": null })
            setTimeout(() => {
                dispatch('sentNCommand', { "cmd": "HP_HangUpCtrl", "rid": 4, "para": null })
            }, 300)

            dispatch('stopRecorder', recordPathBak)

            // 如果没有录音文件，直接断开
            if (!recordPathBak) {
                commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                dispatch('Disconnect')
            }

            commit('SET_PREDIALING', false)
            commit('SET_ISDIALONLINE', false)
            commit('SET_IS_CONNECTED', false)
            commit('SET_P_STATUS', 0)
            const newInfo = { ...state.modalCurentInfo, zipid: null }
            commit('SET_MODALCURENTINFO', newInfo)
            commit('SET_PHONECODE', "")
            commit('SET_PHONECODESHOW', "")

            setTimeout(() => {
                commit('SET_HANGUP_LOCK', false)
            }, 8000)
        },

        PhoneCallEnd({ dispatch }) {
            console.log('用户点击挂断按钮')
            dispatch('handleAllHangUp')
        },

        pollPhoneStatus({ state, dispatch }) {
            if (!state.wsClient || state.wsClient.readyState !== WebSocket.OPEN) return
            dispatch('sentNCommand', { cmd: "HP_GetPhoneStatus", rid: 8, para: null })
        },

        PhoneCall({ commit, state, dispatch }, { phone, zipid }) {
            // ----- 新增：检查 WS 连接状态 -----
            if (!state.wsClient || state.wsClient.readyState !== WebSocket.OPEN) {
                message.error('设备未连接，请先连接设备');
                return;
            }
            let now = new Date()
            let year = now.getFullYear()
            let month = String(now.getMonth() + 1).padStart(2, '0')
            let day = String(now.getDate()).padStart(2, '0')
            let hours = String(now.getHours()).padStart(2, '0')
            let minutes = String(now.getMinutes()).padStart(2, '0')
            let seconds = String(now.getSeconds()).padStart(2, '0')

            let folder = `${year}${month}`
            let dateTimeStr = year + month + day + hours + minutes + seconds
            let cleanPhone = String(phone).replace(/\D/g, '')
            let cleanZipid = String(zipid).replace(/\D/g, '')
            let fileName = `${cleanPhone}_${cleanZipid}_${dateTimeStr}.wav`
            let wavpath = `D:\\usbphonerecord\\${folder}\\${fileName}`

            commit('SET_INP_RECORDADDR', wavpath)
            console.log('录音文件路径:', wavpath)

            dispatch('sentNCommand', { "cmd": "HP_OffHookCtrl", "rid": 3, "para": null })

            setTimeout(() => {
                dispatch('sentNCommand', { "cmd": "HP_StartDial", "rid": 5, "para": phone })
                commit('SET_PREDIALING', true)
                setTimeout(() => {
                    if (state.r_status !== 1) {
                        dispatch('autoRecord')
                    }
                }, 500)

                if (state.callMonitorTimer) {
                    clearInterval(state.callMonitorTimer)
                    commit('SET_CALL_MONITOR_TIMER', null)
                }
                commit('SET_IS_CONNECTED', false)
                let startTime = Date.now()
                let timer = setInterval(() => {
                    dispatch('pollPhoneStatus')

                    if (state.r_status === 0) {
                        clearInterval(timer)
                        commit('SET_CALL_MONITOR_TIMER', null)
                        return
                    }
                    if (state.p_status === 0) {
                        console.log('定时器检测挂机，执行统一挂断')
                        dispatch('handleAllHangUp')
                        clearInterval(timer)
                        commit('SET_CALL_MONITOR_TIMER', null)
                        return
                    }
                    const elapsed = Date.now() - startTime
                    if (state.r_status === 1 && elapsed > 600000) {
                        dispatch('handleAllHangUp')
                        clearInterval(timer)
                        commit('SET_CALL_MONITOR_TIMER', null)
                        commit('SET_P_STATUS', 0)
                    }
                }, 3000)
                commit('SET_CALL_MONITOR_TIMER', timer)
            }, 2000)
        },

        SendMsg({ dispatch }, payload) {
            dispatch('sentCommand', { "cmd": "HP_SendSmsText", "rid": 25, "paraJson": { "Para": payload.msg, "Num": payload.phone } })
        },

        // ========== 修改 Connect：加入锁机制 ==========
        Connect({ commit, state, dispatch }) {
            // ----- 检查锁 -----
            const existingLock = localStorage.getItem('usbphone_lock')
            if (existingLock) {
                dispatch('pushTip', '设备正在被其他标签页使用，请先关闭该标签页的拨号面板')
                message.warning('设备正在被其他标签页使用')
                return
            }
            // 获取锁
            const lockId = Date.now() + '_' + Math.random().toString(36).substr(2, 6)
            localStorage.setItem('usbphone_lock', lockId)
            commit('SET_LOCK_ID', lockId)

            // 注册页面卸载时释放锁
            const beforeUnloadHandler = () => {
                if (state.lockId) {
                    localStorage.removeItem('usbphone_lock')
                }
            }
            window.addEventListener('beforeunload', beforeUnloadHandler)
            commit('SET_BEFOREUNLOAD_HANDLER', beforeUnloadHandler)

            // ---- 原有连接逻辑 ----
            commit('SET_MANUAL_CLOSE', false)
            dispatch('pushTip', '--')
            let wsip = state.wsip
            if (wsip == null || wsip == "") {
                dispatch('pushTip', '服务器地址不能为空.')
                return
            }
            dispatch('pushTip', '开始连接.')
            let wsClient = new WebSocket(wsip)
            commit('SET_WSCLIENT', wsClient)
            const actionDispatch = dispatch
            wsClient.onopen = function () {
                actionDispatch('judgeConnect')
                actionDispatch('oNreceid')
                actionDispatch('startHeartBeat')
            }
        },

        oNreceid({ commit, state, dispatch }) {
            const actionDispatch = dispatch
            let lastHandleTime = 0

            state.wsClient.onmessage = function (e) {
                const now = Date.now()
                const data = e.data
                if (!data || data.trim() === "") return
                let isCriticalMsg = false
                try {
                    const json = JSON.parse(data)
                    if (json.rid === 16 || json.rid === 17 || json.rid === 30 || json.type === '514' || json.type === '515') {
                        isCriticalMsg = true
                    }
                } catch (err) { }

                if (!isCriticalMsg && now - lastHandleTime < 600) return
                lastHandleTime = now

                try {
                    const jsonData = JSON.parse(data)
                    if (jsonData.event === 'HP_MsgEvent') {
                        const type = jsonData.type
                        if (['503', '504', '514', '515'].includes(type)) {
                            commit('SET_LAST_CALL_EVENT_TIME')
                        }
                    }
                } catch (e) { }
                commit('SET_LAST_MESSAGE_TIME')
                actionDispatch('ExplainCommane', data)
            }

            state.wsClient.onclose = function () {
                console.log('WS连接关闭，清空所有定时器')
                actionDispatch('stopHeartBeat')

                if (state.callMonitorTimer) {
                    clearInterval(state.callMonitorTimer)
                    commit('SET_CALL_MONITOR_TIMER', null)
                }
                if (state.incomTimeout) {
                    clearTimeout(state.incomTimeout)
                    commit('SET_INCOM_TIMEOUT', null)
                }
                if (state.autoRecordID) {
                    clearTimeout(state.autoRecordID)
                    commit('SET_AUTORECORDID', null)
                }
                if (state.dlyDlokTimeout) {
                    clearTimeout(state.dlyDlokTimeout)
                    commit('SET_DLYDLOKTIMEOUT', null)
                }
                if (state.uploadTimer) {
                    clearTimeout(state.uploadTimer)
                    commit('SET_UPLOAD_TIMER', null)
                }
                commit('SET_UPLOADING_RECORD', false)
                commit('SET_STOP_RECORD_LOCK', false)
                commit('SET_HANGUP_LOCK', false)
                commit('SET_INP_RECORDADDR', '')

                commit('SET_WSCLIENT', null)

                // 主动关闭不重连，异常断开才重连
                if (state.isManualClose) {
                    console.log('【主动断开】不自动重连，设备已释放')
                    commit('SET_MANUAL_CLOSE', false) // 重置标记
                } else {
                    console.log('【异常断开】1.2秒后自动重连')
                    actionDispatch('judgeConnect')
                }
            }
        },

        judgeConnect({ commit, state, dispatch }) {
            if (!state.wsClient) {
                if (state.isManualClose) return
                dispatch('pushTip', "连接已销毁，准备自动重连")
                dispatch('reInit')
                setTimeout(() => { dispatch('Connect') }, 1200)
                return
            }
            let wsClient = state.wsClient
            if (wsClient.readyState === WebSocket.CONNECTING) {
                dispatch('pushTip', "正在连接")
            } else if (wsClient.readyState === WebSocket.CLOSING) {
                dispatch('pushTip', "正在断开连接")
            } else if (wsClient.readyState === WebSocket.OPEN) {
                dispatch('pushTip', "已连接上：" + wsClient.url + " 可以通讯了")
                dispatch('onDevInit')
            } else if (wsClient.readyState === WebSocket.CLOSED) {
                if (state.isManualClose) return
                dispatch('pushTip', "连接已关闭，自动重连中")
                dispatch('reInit')
                setTimeout(() => { dispatch('Connect') }, 1200)
            }
        },

        onDevInit({ dispatch }) {
            dispatch('sentNCommand', { "cmd": "HP_Init", "rid": 1, "para": "0" })
        },

        sentNCommand({ dispatch }, payload) {
            let strcommand = upUtils.commandNormal(payload.cmd, payload.rid, payload.para)
            dispatch('safeSend', strcommand)
        },
        sentCommand({ dispatch }, payload) {
            let strcommand = upUtils.commandFull(payload.cmd, payload.rid, payload.paraJson)
            dispatch('safeSend', strcommand)
        },
        rsendCommand({ state, dispatch }) {
            dispatch('pushTip', state.pre_command)
            dispatch('safeSend', state.pre_command)
        },

        reInit({ commit, state, dispatch }) {
            if (state.callMonitorTimer) {
                clearInterval(state.callMonitorTimer)
                commit('SET_CALL_MONITOR_TIMER', null)
            }
            if (state.incomTimeout) {
                clearTimeout(state.incomTimeout)
                commit('SET_INCOM_TIMEOUT', null)
            }
            if (state.autoRecordID) {
                clearTimeout(state.autoRecordID)
                commit('SET_AUTORECORDID', null)
            }
            if (state.dlyDlokTimeout) {
                clearTimeout(state.dlyDlokTimeout)
                commit('SET_DLYDLOKTIMEOUT', null)
            }
            if (state.uploadTimer) {
                clearTimeout(state.uploadTimer)
                commit('SET_UPLOAD_TIMER', null)
            }

            commit('SET_P_STATUS', 0)
            commit('SET_A_STATUS', 0)
            commit('SET_DV_STATUS', 0)
            commit('SET_ICM_FLAG', 0)
            commit('SET_PRE_COMMAND', '')
            commit('SET_RD_ICM', false)
            commit('SET_PHONECODE', "")
            commit('SET_PHONECODESHOW', "")
            commit('SET_INP_RECORDADDR', '')
            commit('SET_UPLOADING_RECORD', false)
            commit('SET_STOP_RECORD_LOCK', false)
            commit('SET_HANGUP_LOCK', false)
            commit('SET_UPLOAD_RETRIED', false)
            dispatch('showDialDlg')
            commit('SET_WSCLIENT', null)
        },

        onWSClose({ state }) {
            if (state.wsClient) { state.wsClient.close() }
        },
        pushTip({ state }, tip) { state.tip.push(tip) },
        pushPCS({ commit, state }) {
            commit('SET_SPUSH', [])
            commit('SET_PHONECODESHOW', "")
            commit('SET_INP_PHONECODE', state.phoneCodeShow)
        },
        clearTimeoutF({ commit, state }) {
            if (state.incomTimeout != null) {
                clearTimeout(state.incomTimeout)
                commit('SET_INCOM_TIMEOUT', null)
            }
        },
        setP_status({ commit, state }, status_temp) {
            commit('SET_PRE_P_STATUS', state.p_status)
            commit('SET_P_STATUS', status_temp)
        },
        showDialDlg() { },
        showUIDialStatus() { },

        autoRecord({ state, dispatch }) {
            if (state.p_status !== 1) {
                console.log('[autoRecord拦截] 非摘机状态，禁止录音')
                return
            }
            if (state.isHangUping) {
                console.log('[autoRecord拦截] 正在挂断流程，禁止录音')
                return
            }
            if (state.isStoppingRecord) {
                console.log('[autoRecord拦截] 正在停止录音，禁止重复启动')
                return
            }
            const path = state.inp_recordaddr
            if (!path) {
                console.log('[autoRecord拦截] 录音路径为空，禁止录音')
                return
            }
            dispatch('sentCommand', {
                "cmd": "HP_StartRecordFile",
                "rid": 16,
                "paraJson": { "type": 1, "Para": path }
            })
        },

        stopRecorder({ commit, state, dispatch }, recordPath) {
            if (state.isStoppingRecord) return
            commit('SET_STOP_RECORD_LOCK', true)

            if (state.uploadingRecord) {
                commit('SET_STOP_RECORD_LOCK', false)
                return
            }

            console.log('执行停止录音指令')

            if (state.uploadTimer) {
                clearTimeout(state.uploadTimer)
                commit('SET_UPLOAD_TIMER', null)
            }

            dispatch('sentCommand', {
                "cmd": "HP_StopRecordFile",
                "rid": 17,
                "paraJson": { "type": 1, "path": "", "user": "", "pawd": "" }
            })
            commit('SET_R_STATUS', 0)

            const currentRecordPath = recordPath || state.inp_recordaddr

            const waitKeepAliveTimer = setInterval(() => {
                dispatch('pollPhoneStatus')
            }, 1500)

            const timerId = setTimeout(() => {
                clearInterval(waitKeepAliveTimer)
                commit('SET_UPLOADING_RECORD', true)
                const path = currentRecordPath
                if (!path) {
                    console.warn('无录音文件路径，跳过上传')
                    commit('SET_UPLOADING_RECORD', false)
                    commit('SET_STOP_RECORD_LOCK', false)
                    // 无录音文件，直接断开
                    if (state.shouldDisconnectAfterUpload) {
                        commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                        dispatch('Disconnect')
                    }
                    return
                }
                message.loading('正在上传录音文件...', 2)
                dispatch('sentCommand', {
                    "cmd": "HP_UpLoadFile",
                    "rid": 30,
                    "paraJson": { "remote": "hncs.cskaiyela.com/admin/v1/upload", "localfile": path }
                })

                // 上传超时处理
                setTimeout(() => {
                    if (state.uploadingRecord) {
                        commit('SET_UPLOADING_RECORD', false)
                        message.error('录音上传超时，已自动解锁')
                        if (state.shouldDisconnectAfterUpload) {
                            commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                            dispatch('Disconnect')
                        }
                    }
                }, 10000)

                commit('SET_UPLOAD_TIMER', null)
                commit('SET_STOP_RECORD_LOCK', false)
            }, 4000)

            commit('SET_UPLOAD_TIMER', timerId)
        },

        retryUpload({ commit, state, dispatch }, path) {
            if (state.uploadRetried) return
            commit('SET_UPLOAD_RETRIED', true)
            console.log('录音上传失败，2秒后重试...')

            setTimeout(() => {
                if (!state.wsClient || state.wsClient.readyState !== WebSocket.OPEN) {
                    commit('SET_UPLOADING_RECORD', false)
                    // 重试时 WS 已关闭，直接断开
                    if (state.shouldDisconnectAfterUpload) {
                        commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                        dispatch('Disconnect')
                    }
                    return
                }
                message.loading('重试上传录音...', 2)
                dispatch('sentCommand', {
                    "cmd": "HP_UpLoadFile",
                    "rid": 30,
                    "paraJson": { "remote": "hncs.cskaiyela.com/admin/v1/upload", "localfile": path }
                })
            }, 2000)
        },

        answer_end({ dispatch }) { dispatch('handleAllHangUp') },
        addInp_phonecode({ commit, state }, num) {
            let spush = [...state.spush, num]
            commit('SET_SPUSH', spush)
            commit('SET_PHONECODESHOW', spush.join(""))
            commit('SET_INP_PHONECODE', state.phoneCodeShow)
        },
        dloffHookDelay() { },

        ExplainCommane({ commit, state, dispatch }, command) {
            try { JSON.parse(command) } catch (SyntaxError) { return }
            const jsonString = JSON.parse(command)
            const event = jsonString.event
            const ret = jsonString.ret
            if (event == null && ret == null) return

            if (event != null) {
                const type = jsonString.type
                const lParam = jsonString.data.lParam
                switch (type) {
                    case "501":
                    case "511":
                        commit('SET_ICM_FLAG', type === "511" ? 1 : 0)
                        commit('SET_CNNSTATE', '设备已连接')
                        break
                    case "512":
                        commit('SET_ICM_FLAG', 1)
                        commit('SET_CNNSTATE', lParam == 1 ? '设备已连接(联机成功)' : '设备已连接(联机不成功)')
                        break
                    case "502":
                        if (lParam == "0L") {
                            commit('SET_CNNSTATE', '设备已全部断开')
                        } else commit('SET_CNNSTATE', '已断开设备')
                        dispatch('onWSClose')
                        break
                    case "515":
                        commit('SET_LAST_CALL_EVENT_TIME')
                        if (lParam == 1) {
                            message.info('对方已摘机')
                            commit('SET_IS_CONNECTED', true)
                        } else {
                            message.info('对方已挂机')
                            commit('SET_IS_CONNECTED', false)
                            dispatch('handleAllHangUp')
                        }
                        break
                    case "516":
                        message.info(lParam == 1 ? '耳机插入' : '耳机拔出')
                        break
                    case "517":
                        dispatch('pushTip', "知信内容：" + lParam)
                        break
                    case "518":
                        message.info(lParam)
                        break

                    case "514":
                        if (state.isHangUping) {
                            console.log('[514拦截] 正在挂断流程中，忽略514事件')
                            return
                        }
                        if (state.ringCount > 0 && state.a_status == 1) {
                            dispatch('sentNCommand', { "cmd": "HP_SetLeaveRecord", "rid": 10, "para": "1" })
                            dispatch('showincomDlg')
                            return
                        }
                        dispatch('clearTimeoutF')
                        dispatch('setP_status', 1)
                        commit('SET_RINGCOUNT', 0)
                        commit('SET_A_STATUS', 0)
                        dispatch('showDialDlg')
                        commit('SET_INP_PHONECODE', state.phoneCodeShow)

                        if (state.autoRecordID) {
                            clearTimeout(state.autoRecordID)
                            commit('SET_AUTORECORDID', null)
                        }
                        if (state.r_status == 1) dispatch('stopRecorder')

                        const autoRecordID = setTimeout(() => {
                            if (state.p_status === 1 && state.r_status == 0 && state.inp_recordaddr) {
                                dispatch('autoRecord')
                            }
                        }, 2000)
                        commit('SET_AUTORECORDID', autoRecordID)
                        dispatch('showUIDialStatus', state.p_status)
                        break

                    case "503":
                        if (state.ringCount > 0 && state.a_status == 1) {
                            dispatch('sentNCommand', { "cmd": "HP_SetLeaveRecord", "rid": 10, "para": "1" })
                            dispatch('showincomDlg')
                            return
                        }
                        dispatch('clearTimeoutF')
                        dispatch('setP_status', 1)
                        commit('SET_RINGCOUNT', 0)
                        commit('SET_A_STATUS', 0)
                        dispatch('showDialDlg')
                        commit('SET_INP_PHONECODE', state.phoneCodeShow)
                        if (state.r_status == 1 && !state.holdTo503) {
                            commit('SET_HOLDTO503', false)
                            dispatch('stopRecorder')
                        }
                        dispatch('showUIDialStatus', state.p_status)
                        break

                    case "504":
                        dispatch('clearTimeoutF')
                        const hangFlag2 = lParam === 0 || lParam === "0" || lParam === "0L"
                        if (hangFlag2) {
                            console.log('【物理终止/返回按键挂机 type504 lParam=', lParam, '】')
                            commit('SET_P_STATUS', 0)
                            dispatch('handleAllHangUp')
                            commit('SET_RINGCOUNT', 0)
                            commit('SET_A_STATUS', 0)
                            dispatch('pushPCS')
                            commit('SET_PHONECODE', "")
                            commit('SET_PHONECODESHOW', "")
                        } else {
                            commit('SET_P_STATUS', 2)
                            commit('SET_PREDIALING', false)
                        }
                        dispatch('showDialDlg')
                        commit('SET_INP_PHONECODE', state.phoneCodeShow)
                        dispatch('showUIDialStatus', state.p_status)
                        commit('SET_HOLDTO503', false)
                        break

                    case "505":
                        dispatch('showincomDlg')
                        commit('SET_PHONE_ICM', lParam)
                        commit('SET_PHONECODE', lParam)
                        commit('SET_PHONECODESHOW', lParam)
                        dispatch('clearTimeoutF')
                        break

                    case "506":
                        let tempLParam = lParam
                        if (state.icm_flag == 1) {
                            tempLParam = 0
                            commit('SET_RINGCOUNT', 2)
                        }
                        if (tempLParam != 1) {
                            commit('SET_RINGCOUNT', state.ringCount + 1)
                            if (state.ringCount >= 2) {
                                dispatch('showincomDlg')
                                dispatch('clearTimeoutF')
                                const incomTimeout = setTimeout(() => dispatch('incomTimeoutF'), 5000)
                                commit('SET_INCOM_TIMEOUT', incomTimeout)
                            }
                        }
                        break

                    case "507":
                        if (state.p_status == 0) dispatch('setP_status', 1)
                        if (state.has_dial) {
                            dispatch('pushPCS')
                            commit('SET_HAS_DIAL', false)
                        }
                        const temp = upUtils.deASCII(lParam)
                        if (!state.isDialOnline) dispatch('addInp_phonecode', temp)
                        break
                    case "508": break
                    case "509": break
                    case "510":
                        if (lParam == 0) {
                            commit('SET_HOLDTO503', false)
                            dispatch('setP_status', 1)
                        } else {
                            commit('SET_HOLDTO503', true)
                            dispatch('setP_status', 3)
                        }
                        break
                    case "519": dispatch('rsendCommand'); break
                }
            } else {
                const ret = jsonString.ret
                const rid = jsonString.rid
                const data = jsonString.data
                const AnswerData = data?.Ret
                switch (rid) {
                    case 1:
                        if (jsonString.err) {
                            commit('SET_SERIALNO', '设备初始化错误:' + jsonString.err)
                            return
                        }
                        const p_type = data.PhoneType
                        commit('SET_ICM_FLAG', p_type === "4G" ? 1 : 0)
                        commit('SET_CNNSTATE', p_type == "4G" ? '设备已连接(联机成功)' : '设备已连接')
                        commit('SET_SERIALNO', "设备串号:" + data.SerialNo)
                        break
                    case 3:
                        if (AnswerData == "0") {
                            dispatch('setP_status', 1)
                            dispatch('showUIDialStatus', state.p_status)
                        }
                        break
                    case 4:
                    case 26:
                        if (AnswerData == "0") {
                            dispatch('setP_status', 0)
                            commit('SET_A_STATUS', 0)
                            if (state.r_status == 1) dispatch('stopRecorder')
                            dispatch('pushPCS')
                            commit('SET_PHONECODE', "")
                            commit('SET_PHONECODESHOW', "")
                            dispatch('clearTimeoutF')
                            dispatch('showUIDialStatus', state.p_status)
                        }
                        break
                    case 5:
                        if (AnswerData == "0") {
                            commit('SET_A_STATUS', 0)
                            if (state.has_dial) {
                                dispatch('pushPCS')
                                commit('SET_HAS_DIAL', false)
                            }
                            dispatch('clearTimeoutF')
                        }
                        break
                    case 8:
                        switch (AnswerData) {
                            case "0":
                                commit('SET_PHONECODE', "")
                                commit('SET_PHONECODESHOW', "")
                                dispatch('setP_status', 0)
                                if (state.r_status === 1) {
                                    console.log('轮询查询设备为挂机，执行挂断')
                                    dispatch('handleAllHangUp')
                                }
                                break
                            case "1": dispatch('setP_status', 1); break
                            case "2": dispatch('setP_status', 3); break
                            case "3": dispatch('setP_status', 1); break
                        }
                        dispatch('showUIDialStatus', state.p_status)
                        break
                    case 16:
                        if (AnswerData == "0") {
                            commit('SET_R_STATUS', 1)
                            console.log('录音启动成功')
                        } else message.error(`录音失败 错误码${AnswerData}`)
                        break
                    case 17:
                        commit('SET_R_STATUS', 0)
                        commit('SET_A_STATUS', 0)
                        if (AnswerData != "0") message.info("停止录音失败")
                        break

                    case 30:
                        if (state.uploadTipLock && state.uploadRetried) {
                            commit('SET_UPLOADING_RECORD', false)
                            // 上传完成后检查是否需要断开
                            if (state.shouldDisconnectAfterUpload) {
                                commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                                dispatch('Disconnect')
                            }
                            break
                        }
                        if (AnswerData == "0") {
                            if (!state.uploadTipLock) {
                                commit('SET_UPLOAD_TIP_LOCK', true)
                                message.success('录音上传成功')
                                setTimeout(() => {
                                    commit('SET_UPLOAD_TIP_LOCK', false)
                                }, 1500)
                            }
                            commit('SET_UPLOADING_RECORD', false)
                            // 上传成功，检查是否需要断开
                            if (state.shouldDisconnectAfterUpload) {
                                commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                                dispatch('Disconnect')
                            }
                        } else {
                            if (!state.uploadRetried) {
                                const retryPath = state.inp_recordaddr || ''
                                dispatch('retryUpload', retryPath)
                            } else {
                                if (!state.uploadTipLock) {
                                    commit('SET_UPLOAD_TIP_LOCK', true)
                                    message.error('录音上传失败')
                                    setTimeout(() => {
                                        commit('SET_UPLOAD_TIP_LOCK', false)
                                    }, 1500)
                                }
                                commit('SET_UPLOADING_RECORD', false)
                                // 上传失败，也断开
                                if (state.shouldDisconnectAfterUpload) {
                                    commit('SET_SHOULD_DISCONNECT_AFTER_UPLOAD', false)
                                    dispatch('Disconnect')
                                }
                            }
                        }
                        break
                    case 25:
                        message.success(AnswerData == 0 ? "短信发送成功" : "短信发送失败")
                        break
                }
            }
        },
        incomTimeoutF({ commit, state, dispatch }) {
            commit('SET_PHONECODE', "")
            commit('SET_PHONECODESHOW', "")
            dispatch('showDialDlg')
        },
        NotSendStopREvent() { },
        showincomDlg() { }
    },
    namespaced: true
}

const upUtils = {
    commandNormal: function (cmd, rid, Para) {
        const jsonp = Para !== null ? { "Para": Para } : {}
        return JSON.stringify({ "req": cmd, "rid": rid, "para": jsonp })
    },
    commandFull: function (cmd, rid, paraJson) {
        return JSON.stringify({ "req": cmd, "rid": rid, "para": paraJson })
    },
    deASCII: function (num) {
        const map = { 48: '0', 49: '1', 50: '2', 51: '3', 52: '4', 53: '5', 54: '6', 55: '7', 56: '8', 57: '9', 35: '#', 42: '*' }
        return map[num] || null
    }
}
export default usbphone
